export default {
  getGradeLevelsRequest (state) {
    state.loading = true
    state.gradeLevels = []
  },
  getGradeLevelsSuccess (state, data) {
    state.loading = false
    state.gradeLevels = data
  },
  getGradeLevelsFailure (state) {
    state.loading = true
    state.gradeLevels = []
  }
}
